var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/buttons.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"newAddressInPaymentForm")) {
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"newAddress")) {
output += "\n\n        <div class=\"g-address-payment__button-save\">\n\n            <button type=\"button\" name=\"save\" value=\"";
output += runtime.suppressValue((lineno = 6, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_save",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\" data-cm-element=\"address-save\" class=\"c-button-primary js-account-address-new-save\" data-qa-save-new-address />\n                ";
output += runtime.suppressValue((lineno = 7, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_save",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </button>\n\n        </div>\n\n        <div class=\"g-address-payment__button-cancel\">\n\n            <div class=\"c-form__field c-address-book__button-cancel\">\n\n                <button type=\"reset\" class=\"c-button-text c-button-text--adjacent c-address-book__button-cancel--link js-account-address-new-cancel\" data-qa-cancel-new-address>\n\n                    ";
output += runtime.suppressValue((lineno = 18, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_cancel",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                </button>\n\n            </div>\n\n        </div>\n\n    ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")) {
output += "\n\n        <div class=\"g-address-payment__button-save ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n            <button type=\"button\" name=\"save\" value=\"";
output += runtime.suppressValue((lineno = 30, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_save",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\" class=\"c-button-primary js-account-address-edit-save\" data-address-id=\"";
output += runtime.suppressValue(runtime.memberLookup(((lineno = 30, colno = 172, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"id"), env.opts.autoescape);
output += "\" data-cm-element=\"address-save\" data-qa-save-edit-address />\n                 ";
output += runtime.suppressValue((lineno = 31, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_save",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </button>\n\n        </div>\n\n        <div class=\"g-address-payment__button-cancel ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n            <div class=\"c-form__field c-address-book__button-cancel\">\n\n                <button type=\"reset\" class=\"c-button-text c-button-text--adjacent c-address-book__button-cancel--link js-account-address-edit-cancel\" data-qa-cancel-edit-address>\n\n                    ";
output += runtime.suppressValue((lineno = 42, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_cancel",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                </button>\n\n            </div>\n\n        </div>\n\n    ";
;
}
;
}
output += "\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/buttons.j2"] , dependencies)